import { ConcreteTestSet } from '../../../../ConcreteTestSetTrackerContext/types'
import { useColumns } from './hooks/useColumns'
import { useExpand } from './hooks/useExpand'
import RelationTable from '../RelationTable'
import { Report } from '@cims-online/shared'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'

const Tests: React.FC<ConcreteTestSet> = ({
  concreteTests,
  placementDate,
  globalId,
}) => {
  const expand = useExpand(placementDate)
  const columns = useColumns()
  const dependencies = useReportURLDependencies()
  return (
    <RelationTable
      columns={columns}
      records={concreteTests}
      rowKey="globalId"
      expand={expand}
      actions={{
        header: {
          custom: [
            {
              type: 'externalLink',
              href: Report.ConcreteTestSetCylinders.toURL({
                globalId,
                ...dependencies,
              }),
              label: Report.ConcreteTestSetCylinders.name,
            },
          ],
        },
      }}
    />
  )
}

export default Tests
